import React from 'react'
import { Route, Switch } from 'react-router'
import ReportVehicleChecks from './ReportVehicleChecks'

const Components = props => (
    <Switch>
        <Route exact path={props.match.url} component={ReportVehicleChecks} />
    </Switch>
)

export default Components
